// Algolia configuration
import algoliasearch from 'algoliasearch';
import { remoteConfig } from './firebase/config';

// Name of the index to search from
export const algoliaIndexName = 'events';

// API Key stored and retrieved from Firebase remote config
export const searchClient = async () => {
  let search;
  await remoteConfig
    .fetchAndActivate()
    .then(() => {
      return remoteConfig.getAll();
    })
    .then(remoteFlags => {
      let appId = remoteFlags['algolia_appid'].asString();
      let apiKey = remoteFlags['algolia_apikey'].asString();
      search = algoliasearch(appId, apiKey);
    });
  return search;
};
